import React, { memo } from "react";

import {
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerContent,
  DrawerCloseButton,
  VStack,
  Text,
  Button,
  Center,
} from "@chakra-ui/react";
import Link from "modules/layouts/_shared/link";
import { SupportLogoIcon } from "modules/icons";

const SupportDrawer = () => (
  <DrawerContent>
    <DrawerCloseButton right={0} left={1} />

    <DrawerHeader>
      <Center fontWeight="bold">Support</Center>
    </DrawerHeader>

    <DrawerBody>
      <VStack spacing={30}>
        <SupportLogoIcon boxSize={275} />
        <VStack spacing={0}>
          <Text fontWeight={700} fontSize={20}>
            Need Help?
          </Text>
        </VStack>
        <Link href="https://support.utilizecore.com/tickets-view/" isExternal>
          <Button w={180}>Submit Ticket</Button>
        </Link>
        <VStack spacing={0}>
          <Text fontWeight={700} fontSize={20}>
            Synco Help Center
          </Text>
          <Text>Browse FAQs and learn how to use Synco.</Text>
        </VStack>
        <Link href="https://help.utilizecore.com/support-universe" isExternal>
          <Button w={180}>View Articles</Button>
        </Link>
      </VStack>
    </DrawerBody>

    <DrawerFooter />
  </DrawerContent>
);

export default memo(SupportDrawer);
